import {
  type AppError,
  InvalidTokenError,
  NotAuthorizedError,
  type Result,
} from '@packages/utils';
import type {z} from 'zod';
import {DEFAULT_API_VERSION} from '../../config/apiVersion';
import {defaultClient} from '../../lib/defaultClient';
import {UpdateAccessTokenResponse} from '../entities/session/schema';
import type {ResultLogin} from './loginRepository';

export type UpdateAccessTokenResponseType = z.infer<
  typeof UpdateAccessTokenResponse
>;
export type UpdateAccessTokenValueType = Result<
  UpdateAccessTokenResponseType,
  AppError
>;

export const refreshAccesstoken = async ({
  refreshToken,
  version = DEFAULT_API_VERSION,
}: {
  refreshToken?: string;
  version?: string;
}): Promise<ResultLogin> => {
  const result: UpdateAccessTokenValueType = await defaultClient.put(
    `/${version}/users/refresh-access-token`,
    UpdateAccessTokenResponse,
    {
      refreshToken,
    },
  );

  // 401のみリフレッシュトークンの失効とみなす。
  // 5xxや通信断をセッション切れ扱いにするとユーザーがログアウトされてしまうため、
  // それ以外のエラーは種別を保ったまま返す
  if (!result.ok && result.error === NotAuthorizedError) {
    return {
      ok: false,
      error: InvalidTokenError,
    };
  }

  return result;
};
